import { academiaMejiasApi } from "../academiaMejiasApi";

export const getInscripcionesByGroupId = async (token: string, id: number) => {
  try {
    // Haces la llamada POST a tu API para iniciar sesión
    const { data } = await academiaMejiasApi.get(
      `/admin/grupos/inscripciones/${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    return { ok: true, data };
  } catch (error: any) {
    // Aquí capturas el error y retornas un objeto indicando el fallo
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};

export const editInscripcion = async (token: string, id: number, data: any) => {
  try {
    const response = await academiaMejiasApi.put(
      `/admin/inscripciones/${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    return { ok: true, data: response.data };
  } catch (error: any) {
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};

export const editGrupo = async (
  token: string,
  inscripcionId: number,
  grupoId: number,
  estudianteId: number
) => {
  try {
    const response = await academiaMejiasApi.put(
      `/admin/inscripcion/${inscripcionId}/grupo`,
      { grupoId, estudianteId },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    return { ok: true, data: response.data };
  } catch (error: any) {
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};

export const reenviarPago = async (token: string, inscripcionId: number) => {
  try {
    const response = await academiaMejiasApi.post(
      `/admin/inscripcion/${inscripcionId}/reenvio-pago`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    return { ok: true, data: response.data };
  } catch (error: any) {
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};
export const confirmarPago = async (token: string, inscripcionId: number) => {
  try {
    const response = await academiaMejiasApi.post(
      `/admin/inscripcion/${inscripcionId}/confirmar-pago`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return { ok: true, data: response.data };
  } catch (error: any) {
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};


export const editFactura = async (token: string, inscripcionId: number, data: any) => {
  try {
    const response = await academiaMejiasApi.put(
      `/admin/inscripcion/${inscripcionId}/factura`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    return { ok: true, data: response.data };
  } catch (error: any) {
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};